






































import { Component, Prop, Vue, Watch, Provide, Emit } from 'vue-property-decorator';
import { mounted } from '@/services/VueTimmer';
import { setTimeout } from 'timers';
import { Debounce } from 'lodash-decorators';
import { copyFile } from 'fs';

@Component
export default class EditBoxToggle extends Vue {
  @Prop({default: () => ""})
  value! :string

  @Emit("onSubmit")
  onSubmit(value){}

  @Provide()
  editValue: string = ""

  @Provide()
  editing:boolean = false

  @Provide()
  skipEditing:boolean = false

  @Provide()
  skipBlur:boolean = false

  async showEditBox(){
    if(this.skipEditing)
      return
    await this.$nextTick()
    this.editing = true
    this.editValue = this.value
    await this.$nextTick();
    (<any>this.$refs.input).focus()
  }


  @mounted
  @Watch("value")
  onValueChange(value,oldValue){
    if(!this.editing)
      this.editValue = value
    else{
      if(value == this.editValue && value != oldValue)
        this.editing = false
    }
  }

  onBlur(){
    this.onBlurDebounce()
  }

  onMouseDown(){
    this.skipBlur = true
    this.onSkipBlurTimeout()
  }

  @Debounce(100)
  onBlurDebounce(){
    console.log("this.skipBlur", this.skipBlur)
    if(this.skipBlur)
      return
    this.skipEditing = true
    this.editValue = this.value
    this.editing=false
    this.onBlurTimeout()
  }

  @Debounce(300)
  onBlurTimeout(){
    this.skipEditing = false
  }

  @Debounce(300)
  onSkipBlurTimeout(){
    this.skipBlur = false
  }
}
